import React from 'react';
import { Filter, TextInput } from 'react-admin';

export const AccountFilters = props =>
  <Filter variant="outlined" {...props}>
    <TextInput source="email" type="email" alwaysOn />
  </Filter>
